import { TokenPayment } from "@multiversx/sdk-core/out";

export enum LoanTypeEnum {
  BorrowEgld = 'BorrowEgld',
  DownPayment = 'Mortgage',
}

export enum LoanStatusEnum {
  Opened = 'Opened',
  Closed = 'Closed',
  Liquidated = 'Liquidated',
  Expired = 'Expired',
  Failed = 'NftPurchaseFailed',
  FailedClosed = 'NftPurchaseFailedClosed',
  TopUpClosed = 'TopUpClosed',
  LiquidationGraced = 'LiquidationGraced',
  ExpirationGraced = 'ExpirationGraced',
}

export function parseLoanTypeEnum(val: string): LoanTypeEnum {
  return LoanTypeEnum[val as Exclude<keyof typeof LoanTypeEnum, 'parse'>];
}

export function parseLoanStatusEnum(val: string): LoanStatusEnum {
  return LoanStatusEnum[val as Exclude<keyof typeof LoanStatusEnum, 'parse'>];
}

//
export interface CommonSettingsType {
  rewards_pool_rate: number,
  epunks_buyback_rate: number,
  team_rate: number,
  epunks_buyback_wallet: string,
  team_wallet: string,
  liquidation_wallet: string,

  lend_epoch_length: number,
  lend_lock_period: number,
  liquidation_threshold: number,
  lend_grace_period: number,
  liquidation_fee: number,

  total_lending_amount: string,
  lend_users: number,
  current_lend_epoch_id: number,
  lend_epoch_start_timestamp: number,
  lend_rewards_pool_amount: string,

  global_liquidation_rate: number,
  global_max_borrow_amount: string,

  borrow_plan_count: number,
  max_borrow_periods: number[],
  borrow_rates: number[],

  accumulated_loan_amount: string,
  total_loan_amount: string,
  total_collateral_amount: string,
  opened_loan_count: number,
  loan_owners: number,
  last_loan_id: number,

  collection_ids: string[],
  collection_collateral_rates: number[],
  collection_trait_counts: number[],
  collection_supplies: number[],

  // lend_user_data: LendUserDataType[],
}

export interface LoanType {
  index: number,  // only for view purpose
  loan_id: number,
  loan_type: LoanTypeEnum,
  loan_status: LoanStatusEnum,
  loan_owner: string,
  loan_collection_id: string,
  loan_nft_nonce: number,
  loan_nft_price: string,
  loan_borrow_amount: string,
  loan_debt_amount: string,
  loan_deadline_timestamp: number,
  loan_borrow_plan_id: number,
  loan_open_timestamp: number,
  loan_close_timestamp: number,
  loan_nft_valuation: string,
  loan_liquidation_price: string,
  loan_cashout: string,
}

export interface LendUserType {
  user_lend_amount: string,
  user_last_lend_timestamp: number,
  lender_rewards_amounts: string[],
  lender_rewards_claimeds: boolean[],

  user_loan_ids: number[],
  user_borrow_amount: string,
  user_debt_amount: string,
}

export interface LendUserDataType {
  user_lend_amount: string,
  user_last_lend_timestamp: number,
  user_address: string,
}

// AMM
export enum PoolStateEnum {
  Inactive = 'Inactive',
  Active = 'Active',
  ActiveButNoSwap = 'ActiveButNoSwap',
}

export enum PoolTypeEnum {
  Liquidity = 'Liquidity',
  Sell = 'Sell',
  Buy = 'Buy',
}

export enum PoolCurveTypeEnum {
  Linear = 'Linear',
  Exponential = 'Exponential',
}

export enum SwapTypeEnum {
  Buy = 'Buy',
  Sell = 'Sell'
}

export function parsePoolStateEnum(val: string): PoolStateEnum {
  return PoolStateEnum[val as Exclude<keyof typeof PoolStateEnum, 'parse'>];
}

export function parsePoolTypeEnum(val: string): PoolTypeEnum {
  return PoolTypeEnum[val as Exclude<keyof typeof PoolTypeEnum, 'parse'>];
}

export function parsePoolCurveTypeEnum(val: string): PoolCurveTypeEnum {
  return PoolCurveTypeEnum[val as Exclude<keyof typeof PoolCurveTypeEnum, 'parse'>];
}

export function parseSwapTypeEnum(val: string): SwapTypeEnum {
  return SwapTypeEnum[val as Exclude<keyof typeof SwapTypeEnum, 'parse'>];
}

export interface NftCollection {
  nft_token_id: string,
  nft_collection_name: string,
  nft_listed_count: number,
  nft_floor_price: string,
  nft_best_offer_price: string,
  nft_offer_tvl: string,
  nft_collection_trading_volume: string,
}

export interface NftCollectionPoolInfo {
  pool_nft_token_id: string,
  pool_id: number,
  pool_owner: string,
  pool_state: PoolStateEnum,
  pool_type: PoolTypeEnum,
  pool_trade_fee_percent: number,
  pool_spot_price: string,
  pool_curve_type: PoolCurveTypeEnum,
  pool_linear_curve_step_amount: string,
  pool_exponential_curve_step_percent: number,
  pool_accumulated_fee: string,
  pool_swap_token_id: string,
  pool_swap_token_decimal: number,
  pool_swap_token_reserve: string,
  pool_buy_order_count: number,
  pool_nft_token_reserve: number,
  pool_spot_sell_price: string,
  pool_trade_buy_price: string,
  pool_trade_sell_price: string,
  service_fee: number,
  pool_delta: string,
  nft_collection_name?: string,
}

export interface PoolNft {
  pool_id: number,
  nft_token_id: string,
  nft_token_nonce: number,
  nft_token_amount: string,
  pool_spot_buy_price: string,
  pool_spot_sell_price: string,
  pool_trade_buy_price: string,
  pool_trade_sell_price: string,
}

export interface PoolActivity {
  index: number,
  pool_nft_token_id: string,
  pool_id: number,
  pool_activity_id: number,
  pool_activity_token_nonce: number,
  pool_activity_token_amount: string,
  pool_activity_caller_address: string,
  pool_activity_type: SwapTypeEnum,
  pool_activity_price: string,
  pool_activity_timestamp: number
}

export interface CollectionData {
  collection_pools: NftCollectionPoolInfo[],
  collection_nfts: PoolNft[],
}

export interface PoolData {
  collection_pools: NftCollectionPoolInfo,
  collection_nfts: PoolNft[],
}


//////////////// FARM ////////////

export enum JewelLendStateEnum {
  Active = "Active",
  Inactive = "Inactive",
}

export function parseJewelLendStateEnum(val: string): JewelLendStateEnum {
  return JewelLendStateEnum[val as Exclude<keyof typeof JewelLendStateEnum, 'parse'>];
}

export interface JewelLendPool {
  deposit_token_id: string,
  ib_token_id: string,
  deposit_token_amount: string,
  ib_token_amount: string,
  loan_amount: string,
  user_deposit_token_balance: string,
  user_ib_token_balance: string,
}
export interface JewelLendContext {
  state: JewelLendStateEnum,
  admins: string[],
  borrow_whitelist: string[],
  lendPool: JewelLendPool[],
}

export enum JewelFarmStateEnum {
  Active = "Active",
  Inactive = "Inactive",
}

export function parseJewelFarmStateEnum(val: string): JewelFarmStateEnum {
  return JewelFarmStateEnum[val as Exclude<keyof typeof JewelFarmStateEnum, 'parse'>];
}

export interface JewelFarmContext {
  farm_id: number,
  dex_pool_address: string,
  dex_farm_address: string,
  token_ids: string[],
  lp_token_id: string,
  farm_token_id: string,
  farm_token_nonce: number,
  farm_token_amount: string,
  pending_reward_token_amount: string,
  borrow_amounts: string[],
  farm_shares_per_token: string[],
  total_farm_share: string,
  opened_position_count: number,
  staked_lp_amount: string,
  lp_price: string,
  reserves: string[],
  lp_total_supply: string,
  apy: number,
}

export interface JewelFarmBaseContext {
  state: JewelFarmStateEnum,
  admins: string[],
  jewel_lend_address: string,
  reward_token_id: string,
  wegld_token_id: string,
  ashswap_governance_address: string,
  ashswap_fee_distributor_address: string,
  ashswap_pool_addresses: string[],
  xexchange_pool_addresses: string[],
  min_compound_rewards_amount: string,
  liquidation_tokens: string[],
  liquidation_thresholds: number[],
  min_deposit_tokens: string[],
  min_deposit_values: string[],
  fee_collector_addresses: string[],
  fee_collector_percents: number[],
  farms: JewelFarmContext[],
  last_position_id: number,
  total_opened_position_count: number,
  user_tokens: any,
  ashswap_tokens: any,
}

export enum JewelFarmPositionStateEnum {
  None = "None",
  Opened = "Opened",
  Closed = "Closed",
  Liquidated = "Liquidated",
}

export function parseJewelFarmPositionStateEnum(val: string): JewelFarmPositionStateEnum {
  return JewelFarmPositionStateEnum[val as Exclude<keyof typeof JewelFarmPositionStateEnum, 'parse'>];
}

export interface EsdtTokenPayment {
  token_identifier: string,
  token_nonce: number,
  amount: string,
}

export interface JewelFarmPosition {
  position_id: number,
  position_farm_id: number,
  position_state: JewelFarmPositionStateEnum,
  position_owner: string,
  position_leverage_percent: number,
  position_debt_token: string,
  position_debt_amount: string,
  position_farm_share: string,
  position_open_timestamp: number,
  position_deposit_payments: EsdtTokenPayment[],
}

export interface JewelFarmPositionSafetyContext {
  position_id: number,
  value: string,
  lp_token_amount: string,
  debt_ratio: number,
  liquidation_threshold: number,
  to_be_liquidated: boolean,
}